import { render } from "./UsoApp.vue?vue&type=template&id=cc7a5730&scoped=true&ts=true"
import script from "./UsoApp.vue?vue&type=script&lang=ts"
export * from "./UsoApp.vue?vue&type=script&lang=ts"

import "./UsoApp.vue?vue&type=style&index=0&id=cc7a5730&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc7a5730"]])

export default __exports__